import React, { useMemo } from 'react';
import _ from 'underscore';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { i18nKeys } from '@bingads-webui-react/file-picker';
import { StringUtils } from '@bingads-webui-clientcenter/common-utils';
import { TaxTypeFormPropTypes } from '../shapes';
import { GlobalTaxForm } from './global-taxform';
import { EmptyTaxForm } from './empty-taxform';
import { registerTaxform } from '../taxform-store';
import { EmptyViewTaxForm } from './viewtaxforms/empty-viewtaxform';
import { OMTaxViewTaxForm } from './viewtaxforms/oman-viewtaxform';
import { CustomValidateItems } from '../validator';
import { withViewTaxFormWithFilledEmptyTaxValue, withTaxFormByPilot, getTaxTypeLabel } from '../utils';
import { GlobalTaxIdHelpPopUpId, FileScenarioMapping, GlobalTaxIdCountryCodeToPilots, GlobalFilePickerRequiredErrorMessage } from '../constants';

const {
  TaxOMVatNumberRegExp, TaxType, CountryCode, TaxCertLabel, TaxInfo, TaxLabelFormat,
} = Constants;
const { regexTest } = StringUtils;
const taxIdValidator = _.partial(regexTest, TaxOMVatNumberRegExp);

const taxSchemaGetter = ({ isReverseChargeDocumentAttestationRequired = false }) => ({
  name: 'Oman Taxation Validation Schema',
  type: 'object',
  properties: {
    [TaxType.VatNumber]: {
      type: 'string',
      required: false,
      helpPopupTopic: GlobalTaxIdHelpPopUpId,
    },
    [TaxInfo.ReverseChargeDocumentAttestation]: {
      type: 'string',
      required: isReverseChargeDocumentAttestationRequired,
    },
  },
});

const OMTaxForm = ({
  i18n,
  onValidate,
  showLineByLineFormGroup,
  showTaxFilePicker,
  alwaysShowError,
  data,
  mtData,
  taxCertification,
  mtTaxCertification,
  urlBuilder,
  disabled,
}) => {
  const taxCertLabel = useMemo(() => i18n.getString(TaxCertLabel.TaxCertificateOrEquivalentProof), [i18n]);
  const taxTypeLabel = useMemo(() => getTaxTypeLabel(TaxType.VatNumber, i18n, { countryCode: CountryCode.OM }), [i18n]);
  const vatValidatorErrorMessage = useMemo(() => i18n.getString(CustomValidateItems.OmanVATFormatValidation), [i18n]);
  const vatLabel = useMemo(() => getTaxTypeLabel(TaxType.VatNumber, i18n, { labelFormat: TaxLabelFormat.RequiredForBusiness, countryCode: CountryCode.OM }), [i18n]);
  const customStrings = useMemo(() => ({
    [i18nKeys.FilePicker_ErrorMessage_Required]: i18n.getString(GlobalFilePickerRequiredErrorMessage, {
      taxId: taxTypeLabel,
    }),
  }), [i18n, taxTypeLabel]);

  return (
    <GlobalTaxForm
      i18n={i18n}
      onValidate={onValidate}
      taxSchemaGetter={taxSchemaGetter}
      vatLabel={vatLabel}
      customStrings={customStrings}
      showLineByLineFormGroup={showLineByLineFormGroup}
      vatValidatorErrorMessage={vatValidatorErrorMessage}
      showTaxFilePicker={showTaxFilePicker}
      alwaysShowError={alwaysShowError}
      data={data}
      mtData={mtData}
      taxCertification={taxCertification}
      mtTaxCertification={mtTaxCertification}
      urlBuilder={urlBuilder}
      disabled={disabled}
      taxIdValidator={taxIdValidator}
      taxCertLabel={taxCertLabel}
      taxCertScenario={FileScenarioMapping.OM}
      showReverseDocument
    />
  );
};

OMTaxForm.propTypes = TaxTypeFormPropTypes;

const pilotFlag = GlobalTaxIdCountryCodeToPilots.OM;
const TaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: OMTaxForm, DefaultForm: EmptyTaxForm });
const ViewTaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: OMTaxViewTaxForm, DefaultForm: EmptyViewTaxForm });

registerTaxform('/OM/', TaxForm, withViewTaxFormWithFilledEmptyTaxValue({ ViewTaxForm, getTaxSchema: taxSchemaGetter }));
